import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { finalize } from 'rxjs/operators';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { BasicService } from 'src/app/shared/services/basic.service';
import { ErrorsPlaceholderCellService } from './errors-placeholder-cell.service';
import { Config, MassMessagingError } from './models';
/**
 * /!\ This component is dedicated to the marketing part. /!\
 * Allows to show a 3 dots ellipsis when no errors are found.
 * In the case where there are errors, a click on the number opens a dynamic table in a modal that contains the errors for the given item.
 * The columns depends on the business part.
 */
@Component({
  selector: 'app-errors-placeholder-cell',
  templateUrl: './errors-placeholder-cell.component.html',
  styleUrls: ['./errors-placeholder-cell.component.scss'],
})
export class ErrorsPlaceholderCellComponent implements OnInit {
  @Input() config: Config;
  @Input() errors: number;
  @Input() id: number;

  dataSource = new TableVirtualScrollDataSource([]);
  displayedColumns: string[] = [];
  @ViewChild('errorsTemplateRef') errorsTemplateRef: TemplateRef<any>;

  constructor(
    public dialog: MatDialog,
    private basicService: BasicService,
    private errorsPlaceholderCellService: ErrorsPlaceholderCellService
  ) {}

  ngOnInit() {
    this.displayedColumns = this.config.displayedColumns.map(({ name }) => name);
  }

  showErrors() {
    this.basicService.showSpinner();
    const { domainEndpoint } = this.config;
    this.errorsPlaceholderCellService
      .findAll(domainEndpoint, this.id)
      .pipe(finalize(() => this.basicService.hideSpinner()))
      .subscribe({
        next: (result: MassMessagingError[]) => {
          this.dataSource = new TableVirtualScrollDataSource(result);
          let dialogRef;
          const { titleKey, descriptionKey, confirmBtnKey } = this.config;
          if (!result || !result.length) {
            dialogRef = this.dialog.open(ConfirmDialogComponent, {
              panelClass: 'medium-size',
              data: {
                title: this.basicService.translate(titleKey),
                description: this.basicService.translate('no-results'),
                confirmBtnText: this.basicService.translate('close'),
              },
            });
          } else {
            dialogRef = this.dialog.open(ConfirmDialogComponent, {
              panelClass: 'large-size',
              data: {
                title: this.basicService.translate(titleKey),
                description: this.basicService.translate(descriptionKey),
                templateRef: this.errorsTemplateRef,
                cancelBtnText: this.basicService.translate('close'),
                confirmBtnText: this.basicService.translate(confirmBtnKey),
              },
            });
            dialogRef.afterClosed().subscribe(result => {
              if (result) {
                this.errorsPlaceholderCellService.exportErrorsAsExcel(domainEndpoint, this.id);
              }
            });
          }
        },
      });
  }
}
